import React from 'react';

const BrandList = [
    {
        image: './images/brand/iusa.png'
    },
    {
        image: './images/brand/dicalidad.png'
    },
    {
        image: './images/brand/futura.png'
    },
    {
        image: './images/brand/lasco.png'
    },
    {
        image: './images/brand/charlotte.png'
    },
    
    
]

const BrandPlomeria = ({brandStyle}) => {
    return (
        <ul className={`brand-list ${brandStyle}`}>
            {BrandList.map((data, index) => (
                <li key={index}>
                    <a href="#"><img src={`${data.image}`} alt="Brand Image" /></a>
                </li>
            ))}
        </ul>
    )
}

export default BrandPlomeria;
